import React, { useEffect } from 'react';
import './css/App.css';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { removeAll } from './hooks/hooks.localStorage';
import { useLocation } from 'react-router-dom';

import { I18nProvider } from './i18n';
import BasicRouting from './routing/routing.basicRouting';
import SecurityRouting from './routing/routing.securityRouting';
import PendingApproval from './views/security/view.pending';

// Cursor spotlight: feeds --mx/--my/--spot to the card under the pointer (CSS draws the glow)
const SPOT_SELECTOR = '.card, .kpi-card, .financial-metric-card, .chart-card, .cg-card, .auth-card';
function useCardSpotlight() {
  useEffect(() => {
    if (!window.matchMedia?.('(hover: hover)').matches) return undefined;
    let active = null;
    const onMove = (e) => {
      const el = e.target.closest?.(SPOT_SELECTOR);
      if (active && active !== el) active.style.setProperty('--spot', 0);
      active = el || null;
      if (!el) return;
      const r = el.getBoundingClientRect();
      el.style.setProperty('--mx', `${e.clientX - r.left}px`);
      el.style.setProperty('--my', `${e.clientY - r.top}px`);
      el.style.setProperty('--spot', 0.14);
    };
    document.addEventListener('pointermove', onMove, { passive: true });
    return () => document.removeEventListener('pointermove', onMove);
  }, []);
}

function AppContent() {
  useCardSpotlight();
  const user = useSelector((state) => state.userReducer.user);
  const limit = useSelector((state) => state?.userReducer?.limit);
  const dispatch = useDispatch();
  const location = useLocation();

  const logout = () => {
    dispatch({ type: "logout" });
    removeAll();
  };

  useEffect(() => {
    const now = moment();
    if (limit && now.diff(moment(limit), "M") >= 1) {
      logout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit, location]);

  const isAuthenticated = user?.nom || user?.email;
  const isPending = isAuthenticated && user?.status === 'pending';

  return (
    <div className="App">
      {!isAuthenticated
        ? <SecurityRouting />
        : isPending
          ? <PendingApproval />
          : <BasicRouting />
      }
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        theme="dark"
        style={{ zIndex: 9999 }}
      />
    </div>
  );
}

function App() {
  return (
    <I18nProvider>
      <AppContent />
    </I18nProvider>
  );
}

export default App;
